/**
 * Uploads API URL helpers
 *
 * Centralizes the base uploads URL and project naming used for fetching client data.
 * This module is intentionally lightweight and has no dependency on other services
 * to avoid circular imports.
 */

// Mystery Client files are always fetched through the authenticated Traffix API.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Build a full URL for a client data file on the remote API (without auth)
 * @param {string} filePath - Relative path to the file (e.g., 'signal_fix/Car_gps.geojson')
 * @returns {string} Full API URL
 */
export const getClientFileUrl = (filePath) => {
  const cleanPath = filePath.startsWith('/') ? filePath.slice(1) : filePath;
  return `${API_BASE_URL}/api/mystery-client/files/${cleanPath}`;
};
